
export const ADVANCED_TIER_DEFAULT_VALUES = {
  currentProgramDetails: "",
  trainingPhilosophy: "",
  hasPeriodizationExperience: "not_sure" as const,
  periodizationApproach: "",
  performanceTracking: "app" as const,
  recoveryProtocols: "",
  recentPerformance: "",
  weaknesses: ""
};

export const ADVANCED_TIER_TITLE = "Advanced Program Questions";
export const ADVANCED_TIER_DESCRIPTION = "These questions help fine-tune the program for experienced fitness clients with advanced training needs.";
